var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"erro-404"},[_c('div',{staticClass:"error-cot"},[_c('img',{attrs:{"src":require("../assets/img/upload.png"),"alt":""}}),_c('p',[_vm._v("系统升级中，请稍后再试！")])])])
}]

export { render, staticRenderFns }